import { ContextField } from "@appretio/context-selector";
import { TabItem } from "@appretio/ui-kit";
import type { TemporalContext } from "../../components/temporalContextSelector/data/temporalContextOptions";

export const PAGE_SIZE = 5000;

export const INSEASON_CONTEXT_FIELDS: ContextField[] = [
  "brand",
  "sub_brand",
  "product_line",
  "collection_type",
  "product_category",
  "collection_name",
  "chain",
  "sales_location",
  "country"
];

export const INSEASON_TEMPORAL_PRESELECTED_OPTIONS: TemporalContext = {
  years: [new Date().getFullYear()],
  aggregation_value: 8,
  week_zero: "SALES"
};

export const INSEASON_TABS: TabItem[] = [
  { value: "table", label: "Table" },
  { value: "accuracy", label: "Accuracy" },
  { value: "attribute", label: "Attribute" },
  { value: "category", label: "Category" },
  { value: "colour", label: "Colour" },
  { value: "efficiency", label: "Efficiency" },
  { value: "price", label: "Price" },
  { value: "salesProfile", label: "Sales profile" },
  { value: "sellthrough", label: "Sellthrough" },
  { value: "top10", label: "Top 10" }
];
